import { render, staticRenderFns } from "./ProcessAssessmentsTab.vue?vue&type=template&id=d7cda510&"
import script from "./ProcessAssessmentsTab.vue?vue&type=script&lang=js&"
export * from "./ProcessAssessmentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports